import { notifySaveSuccess } from '../utils/saveNotification';
import { useCallback, useEffect, useState } from 'react';
import { BlockStack, Button, Card, InlineStack, Modal, Text, TextField } from './admin-ui';
import { settingsError, settingsRequest } from '../api/adminSettings';
import { SettingsFeedback, SettingsLoading } from './SettingsFields';

export default function EmailContentEditor() {
  const [saved, setSaved] = useState(null);
  const [form, setForm] = useState({ subject: '', content: '' });
  const [busy, setBusy] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const load = useCallback(async () => {
    setError('');
    try { const data = await settingsRequest('g-email-content'); setSaved(data); setForm({ subject: data.subject || '', content: data.content || '' }); }
    catch (e) { setError(settingsError(e)); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const save = async (remove = false) => {
    setBusy(true); setError(''); setSuccess('');
    try {
      const data = await settingsRequest('c-u-email-content', remove ? { id: saved.id, is_delete: true } : { ...(saved.id ? { id: saved.id } : {}), ...form });
      setSaved(data); setForm({ subject: data.subject || '', content: data.content || '' }); setDeleting(false);
      if (!remove) notifySaveSuccess();
      setSuccess(remove ? 'Email content deleted.' : 'Email content saved.');
    } catch (e) { setError(settingsError(e)); }
    finally { setBusy(false); }
  };
  const change = key => value => { setForm(prev => ({ ...prev, [key]: value })); setSuccess(''); };
  return <Card><BlockStack gap="400">
    <BlockStack gap="100"><Text as="h2" variant="headingMd">Email content</Text><Text as="p" tone="subdued">Customize the subject and message used in your emails.</Text></BlockStack>
    {!deleting && <SettingsFeedback error={error} success={success} retry={!saved ? load : undefined} />}
    {!saved ? (!error && <SettingsLoading />) : <>
      <TextField label="Subject" value={form.subject} onChange={change('subject')} maxLength={255} disabled={busy} autoComplete="off" />
      <TextField label="Message" value={form.content} onChange={change('content')} maxLength={16000} multiline={5} disabled={busy} autoComplete="off" helpText="This message is added to the existing checkout email." />
      <InlineStack align="space-between" blockAlign="center"><span>{saved.id && <Button variant="plain" tone="critical" disabled={busy} onClick={() => { setError(''); setDeleting(true); }}>Delete content</Button>}</span><Button variant="primary" loading={busy} disabled={!form.subject.trim() || !form.content.trim()} onClick={() => save()}>Save content</Button></InlineStack>
    </>}
    <Modal open={deleting} onClose={() => { if (!busy) setDeleting(false); }} title="Delete email content?" primaryAction={{ content: 'Delete content', destructive: true, loading: busy, onAction: () => save(true) }} secondaryActions={[{ content: 'Cancel', disabled: busy, onAction: () => setDeleting(false) }]}><Modal.Section><BlockStack gap="300"><SettingsFeedback error={error} /><Text as="p">This content will no longer be used for future email attempts. Existing sending history will remain.</Text></BlockStack></Modal.Section></Modal>
  </BlockStack></Card>;
}
